import React from 'react';
import './ServicesPage.css';
import mobileDev from '../assets/mobileDev.jpg'; // Imagem para "Aplicativos Móveis"
import customSystems from '../assets/customSystems.jpg'; // Imagem para "Sistemas Personalizados"
import automation from '../assets/automation.jpg'; // Imagem para "Automação de Processos"

function ServicesPage() {
    return (
        <section className="services" id="servicos">
            <div className="services-container">
                <h2>Serviços</h2>
                <div className="services-grid">
                    <div className="service-card">
                        <img
                            src={mobileDev}
                            alt="Desenvolvimento de aplicativos móveis"
                            className="service-image"
                        />
                        <h3>Aplicativos Móveis</h3>
                        <p>
                            Desenvolvimento de aplicativos multiplataforma com foco em performance e experiência do usuário.
                        </p>
                    </div>
                    <div className="service-card">
                        <img
                            src={customSystems}
                            alt="Sistemas personalizados"
                            className="service-image"
                        />
                        <h3>Sistemas Personalizados</h3>
                        <p>
                            Criação de sistemas sob medida para atender às necessidades específicas do seu negócio.
                        </p>
                    </div>
                    <div className="service-card">
                        <img
                            src={automation}
                            alt="Automação de processos"
                            className="service-image"
                        />
                        <h3>Automação de Processos</h3>
                        <p>
                            Soluções inteligentes que otimizam e automatizam processos, aumentando a eficiência operacional.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ServicesPage;
